import { Outlet } from 'react-router-dom';

import Header from '../header/Header';
import Footer from '../footer/Footer';
import Toasts from '../toasts/Toasts';

function StandardLayout() {
  return (
    <div data-testid="layout-standard">
      <Header />
      <div className="min-h-[calc(100vh_-_96px)] px-4 py-4">
        <Outlet />
      </div>
      <Footer />
      <Toasts />
    </div>
  );
}

export default StandardLayout;
